module.exports = __webpack_public_path__ + "static/coder-70d3cd50f212503be92271e3601d8572.svg";